import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import ReactSelect from 'components/ReactSelect/ReactSelect';

import Option from './Option';
import Value from './Value';
import styles from './FontSizePicker.css';


const FontSizePicker = ({ id, isDesktop, onChange, normalScreenFontSize, selectWrapperClass, labelClass }) => {
  const optionRenderer = useCallback((option) =>
    <span style={{ fontSize: option.font, textTransform: 'capitalize' }}>{option.label}</span>,
  []);

  const fontOptionsByFontSize = {
    12: {
      value: 'VERY_SMALL',
      label: translate('strings.ChatSettings.fontSize.verySmall'),
      font: 12,
    },
    14: {
      value: 'SMALL',
      label: translate('strings.ChatSettings.fontSize.small'),
      font: 14,
    },
    16: {
      value: 'REGULAR',
      label: translate('directory.filter.show.type.regular'),
      font: 16,
    },
    18: {
      value: 'LARGE',
      label: translate('strings.ChatSettings.fontSize.large'),
      font: 18,
    },
    28: {
      value: 'VERY_LARGE',
      label: translate('strings.ChatSettings.fontSize.veryLarge'),
      font: 28,
    },
  };

  const fontSizeTitle = useMemo(() => (
    <div className={classNames([styles.labelText, labelClass])}>
      {translate('v2profile.font.size')}
    </div>
  ), [labelClass]);

  if (!isDesktop) {
    return (
      <div>
        {fontSizeTitle}

        <p className={styles.smallText}>
          {translate('v2profile.font.adjust')}
        </p>
      </div>
    );
  }

  return (
    <div>
      {fontSizeTitle}

      <ReactSelect
        className={styles.selectedFont}
        clearable={false}
        id={id}
        optionComponent={Option}
        optionRenderer={optionRenderer}
        options={Object.values(fontOptionsByFontSize)}
        searchable={false}
        value={fontOptionsByFontSize[normalScreenFontSize]}
        valueComponent={Value}
        wrapperClass={selectWrapperClass}
        onChange={onChange}
      />
    </div>
  );
};

FontSizePicker.defaultProps = {
  id: undefined,
  isDesktop: false,
  labelClass: undefined,
  normalScreenFontSize: 12,
  onChange: () => undefined,
  selectWrapperClass: undefined,
};

FontSizePicker.propTypes = {
  id: PropTypes.string,
  isDesktop: PropTypes.bool,
  labelClass: PropTypes.string,
  normalScreenFontSize: PropTypes.number,
  selectWrapperClass: PropTypes.string,
  onChange: PropTypes.func,
};

export default FontSizePicker;
